import type { InitialGeoLocation } from "@/features/viewer-location";
import type { FindSearch } from "./find-route.contract.ts";

export type FindLocationOrigin = {
    status: "guessed" | "confirmed";
    lat: number;
    lng: number;
};

export function resolveFindLocationOrigin(
    urlSearch: FindSearch,
    estimatedLocation: InitialGeoLocation | null | undefined,
    selectedLocation?: InitialGeoLocation | null,
): FindLocationOrigin | null {
    const fromUrl =
        urlSearch.lat != null && urlSearch.lng != null
            ? { lat: urlSearch.lat, lng: urlSearch.lng }
            : null;
    const point = fromUrl ?? estimatedLocation;
    if (!point) return null;
    const isSelected =
        selectedLocation != null &&
        point.lat === selectedLocation.lat &&
        point.lng === selectedLocation.lng;
    return {
        status:
            urlSearch.locationSource === "estimated" ||
            (!fromUrl && !isSelected)
                ? "guessed"
                : "confirmed",
        lat: point.lat,
        lng: point.lng,
    };
}
